import { Phone } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Advantages } from "@/components/Advantages";
import { Services } from "@/components/Services";
import { BookingSection } from "@/components/BookingSection";
import { Zone } from "@/components/Zone";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#050505] text-white antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Advantages />
        <Services />
        <BookingSection />
        <Zone />
      </main>
      <Footer />
      <a
        href="tel:0602259560"
        data-testid="floating-call-button"
        aria-label="Appeler Motor Select"
        className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#D4AF37] text-black shadow-[0_0_30px_rgba(212,175,55,0.45)] transition-transform hover:scale-110 md:hidden"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
}
